import React, { FunctionComponent } from 'react'
import { Trans, useTranslation } from 'next-i18next'
import { TermLink } from '../TermLink'
import { Grid, Text } from '@afterpaytouch/core'
import { TransProps } from 'react-i18next'

export const Terms: FunctionComponent = () => {
  const { t } = useTranslation()
  const getTranslation = (): TransProps<string> => {
    const components = {
      terms: <TermLink key='verify-identity-passport-terms' href={t('common:termsOfServiceUrl')} />,
      privacy: <TermLink key='verify-identity-passport-privacy' href={t('common:privacyPolicyUrl')} />,
    }

    return { i18nKey: 'verifyIdentity:passport:terms', components }
  }

  return (
    <Grid>
      <Text color='Gray40' size='XXS'>
        <Trans {...getTranslation()} />
      </Text>
    </Grid>
  )
}
